import { Box, Container, Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { LoadingIndicator } from 'src/common/components/LoadingIndicator';
import { formatDollars } from '../../../../common';
import CardComponent from '../../../../common/components/CardComponent';
import { theme } from '../../../../themes';
import { AssociationsTable } from './AssociationsTable';
import { fetchAfslAndModelAssociations } from '../store/thunks';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { Props } from '../container';

export const AssociationsComponent = ({
  loadingProgress,
  modelVersionId,
  dataFeeds,
}: Props): JSX.Element => {
  
const dispatch = useDispatch();
const { afslError, modelAssociations } = useSelector(
    (state: RootState) => state.model.modelAssociations
);

useEffect(() => {
    const moneysoftFeed = dataFeeds?.find(d => d.vendor === "Moneysoft");
    if (!moneysoftFeed?.adviserId || modelVersionId === null) return;

    dispatch(
      fetchAfslAndModelAssociations({
        modelAdviserId: moneysoftFeed.adviserId,
        modelVersionId,
      })
    );
 }, [dataFeeds, modelVersionId, dispatch]);

 return (
    <Container style={{ paddingTop: '20px', paddingBottom: '20px' }}>

      {afslError && (
        <Box marginBottom="16px" padding="12px" style={{ border: '2px solid #cd1604' }}>
          <Typography variant="subtitle1" color="error">
            Unable to load adviser details. Please try again later or contact adviserservices@dash.com.au if the issue persists.
          </Typography>
        </Box>
      )}

      <LoadingIndicator progress={loadingProgress}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <CardComponent
              progress={loadingProgress}
              background={theme.palette.gradient1?.main}
              value={formatDollars(modelAssociations?.fua)}
              subText={'FUA'}
            />
          </Grid>
          <Grid item xs={6}>
            <CardComponent
              progress={loadingProgress}
              background={theme.palette.gradient2?.main}
              value={modelAssociations?.portfolioCount}
              subText={'Portfolios'}
            />
          </Grid>
        </Grid>
      </LoadingIndicator>
      <Grid container spacing={2} style={{ marginTop: '24px' }}>
        <Grid item xs={12}>
          {!!modelAssociations && !!modelAssociations.portfolioExposures && (
            <AssociationsTable progress={loadingProgress} data={modelAssociations?.portfolioExposures} />
          )}
        </Grid>
      </Grid>
    </Container>
  );
};
